import * as React from 'react';
import { useAnalytics } from '../../../contexts/AnalyticsContext';
import { ExternalButtonLink } from '../../../components/Button';

interface Props {
  paymentLink: string;
}

export const PayCaptainLink: React.FC<Props> = ({ paymentLink }) => {
  const analytics = useAnalytics();
  return (
    <ExternalButtonLink
      href={paymentLink}
      icon="external-link"
      rel="noopener noreferrer"
      onClick={() => analytics.track('PaymentLink Shared')}
      target="_blank"
    >
      Pay the captain
    </ExternalButtonLink>
  );
};
